import React, { createContext, useState, ReactNode, useEffect } from "react";

type LoginModalContextType = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: () => void;
};

const initialState: LoginModalContextType = {
  isOpen: false,
  setIsOpen: () => {},
  showModal: () => null,
};

export const LoginModalContext = createContext<LoginModalContextType>(initialState);

export const LoginModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const showModal = () => {
    setIsOpen(true);
  };

  return (
    <LoginModalContext.Provider value={{ showModal, isOpen, setIsOpen }}>
      {children}
    </LoginModalContext.Provider>
  );
};
